import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class usuarioService{
    /******* QUERIES ******/
    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}seguridad/usuario/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarSeriesPorIdUsuario(idUsuario) {
        const response = await axios
            .get(`${ERP}seguridad/usuario/series-por-usuario/${idUsuario}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarPermisosPorIdUsuario(idUsuario) {
        const response = await axios
            .get(`${ERP}seguridad/usuario/usuario-permiso/${idUsuario}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async excel(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async usarioCobranza(idUsuario,param) {
        const response = await axios
            .get(`${ERP}seguridad/usuario/usuario-cobranza?IdUsuario=${idUsuario}&param=${param}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    
    async usarioEstablecimiento(idUsuario,param) {
        const response = await axios
            .get(`${ERP}seguridad/usuario/usuario-cobranza?IdUsuario=${idUsuario}&param=${param}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

      /******* TRANSACCIONES ******/

      async registrar(data) {
        const response = await axios
            .post(`${ERP}seguridad/usuario`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificarContraseniaAdmin(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario/modificar-contrasenia-admin`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificarConfiguracion(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario/modificar-configuracion-admin`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async modificarContraseniaUsuario(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario/modificar-contrasenia-user`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificarSerie(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario/modificar-series`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario/eliminar`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario/activar`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new usuarioService();